/**
 * A function intented to help primarily with null propagation
 *
 * @example `
 * getSafe(() => my.deeply.nested.value, 'foo');
 * `
 * @param input Function to evaluate
 * @param defaultVal default value on fail or null
 */
export function getSafe<T>(input: () => T, defaultVal: T) {
  // Due to the improvements in JITTERS there is a neglible performance hit
  // on try / catch operations.
  // see: https://jsperf.com/try-catch-performance-overhead
  try {
    const result =  input();
    if (result === undefined) {
      return defaultVal;
    }
    return result;
  } catch (e) {
    return defaultVal;
  }
}
